import type { StringIndexedObject } from "@kanda-libs/ks-component-ts";
import { Job } from "@kanda-libs/ks-frontend-services";
import { pipe } from "fp-ts/lib/function";
import { groupBy } from "fp-ts/lib/NonEmptyArray";
import { capitaliseWords } from "common/helpers";
import type { JobStats } from "./types";

export const getJobStatusKey = (job: Job): string =>
  `${job.status}:${job.finance_status}`;

export interface DecodedJobStatusKey {
  status: string;
  financeStatus: string;
}

export const decodeJobStatusKey = (key: string): DecodedJobStatusKey => {
  const [status, financeStatus] = key.split(":");
  return { status, financeStatus };
};

export const getJobStatusLabel = (key: string): string => {
  const decodedKey = decodeJobStatusKey(key);

  const formattedFinanceStatus = capitaliseWords(
    decodedKey.financeStatus.split("_").join(" ")
  );

  return `${capitaliseWords(decodedKey.status)} & ${formattedFinanceStatus}`;
};

export const reduceJobCounts = (jobs: StringIndexedObject<Job[]>) =>
  Object.keys(jobs).reduce((acc, status) => {
    acc[status] = jobs[status].length;
    return acc;
  }, {} as StringIndexedObject<number>);

export const jobCountsGroupedByStatus = (
  jobs: Job[]
): StringIndexedObject<number> =>
  pipe(jobs, groupBy(getJobStatusKey), reduceJobCounts);

export const getJobStats = (jobs: Job[]): JobStats => ({
  total: jobs.length,
  ...jobCountsGroupedByStatus(jobs),
});
